// Testimonial Carousel
const testimonials = document.querySelectorAll('.testimonials');
testimonials.forEach(testimonial => {
    const testimonialCarousel = new Siema({
        selector: testimonial.querySelector('.testimonials__carousel__wrapper'),
        loop: true,
        duration: 500
    });
    let carouselAutoplayInterval = setInterval(() => testimonialCarousel.next(), 5000);
    testimonial.querySelector('.testimonials__nav--prev button').addEventListener('click', () => {
        testimonialCarousel.prev();
        clearInterval(carouselAutoplayInterval);
        carouselAutoplayInterval = setInterval(() => testimonialCarousel.next(), 5000);
    });
    testimonial.querySelector('.testimonials__nav--next button').addEventListener('click', () => {
        testimonialCarousel.next();
        clearInterval(carouselAutoplayInterval);
        carouselAutoplayInterval = setInterval(() => testimonialCarousel.next(), 5000);
    });
});

// Carousels
const carousels = document.querySelectorAll('.carousel');
carousels.forEach(carousel => {
    const carouselSiema = new Siema({
        selector: carousel.querySelector('.carousel__wrapper'),
        loop: true,
        duration: 1000,
        onInit: function(){
            insertDotNavigation(this);
            updateActiveDot(this);
        },
        onChange: function() {
            updateActiveDot(this);
        }
    });
    let carouselAutoplayInterval = setInterval(() => carouselSiema.next(), 5000);
    carousel.querySelector('.carousel__nav__button--prev').addEventListener('click', () => {
        carouselSiema.prev();
        clearInterval(carouselAutoplayInterval);
        carouselAutoplayInterval = setInterval(() => carouselSiema.next(), 5000);
    });
    carousel.querySelector('.carousel__nav__button--next').addEventListener('click', () => {
        carouselSiema.next();
        clearInterval(carouselAutoplayInterval);
        carouselAutoplayInterval = setInterval(() => carouselSiema.next(), 5000);
    });
})

function insertDotNavigation(carousel) {
    // Create the dots navigation element
    carousel.dots = document.createElement('div');
    carousel.dots.classList.add('carousel__nav__dots');
    // Add the dot buttons
    for(let i = 0; i < carousel.innerElements.length; i++) {
        const dot = document.createElement('button');
        dot.setAttribute('aria-label', 'Go to carousel item ' + (i+1));
        dot.addEventListener('click', () => {
            carousel.goTo(i);
        })
        carousel.dots.appendChild(dot);
    }
    // Add the dots navigation element to DOM
    carousel.selector.previousElementSibling.firstElementChild.firstElementChild.insertBefore(carousel.dots, carousel.selector.previousElementSibling.firstElementChild.firstElementChild.lastElementChild);
};

function updateActiveDot(carousel) {
    for(let i = 0; i < carousel.dots.querySelectorAll('button').length; i++) {
        // if current dot matches currentSlide prop, add a class to it, remove otherwise
        const addOrRemove = carousel.currentSlide === i ? 'add' : 'remove';
        carousel.dots.querySelectorAll('button')[i].classList[addOrRemove]('active');
    }
}